import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Field, reduxForm, getFormValues, SubmissionError } from 'redux-form';
import { _t } from "../util/Translator";
import ReCAPTCHA from "react-google-recaptcha";
import ProteccionDeDatosScreen from "../pages/ProteccionDeDatosScreen";
import * as AfeFields from "../components/AfeFields";
import * as Actions from "../actions";
import store from "../store";

const recaptchaRef = React.createRef();

class AcceptLopdFormScreen extends Component {
  state = {};

  
  componentDidMount() {
    console.log("match", this.props);

    //store.dispatch(Actions.getJob(this.props.match.params.id));
  }

  onSubmit = async (formValues) => {

    try {
      let result = await store.dispatch(Actions.acceptLopd(formValues));
      
      this.setState({ isLoading: false });

      this.props.history.push('/home/accept-rgpd/confirmed');

    } catch (error) {
      this.setState({ isLoading: false });

      const errorMessage = (error.response && error.response.data && error.response.data.error_description) ? 
        error.response.data.error_description : "Something went wrong!, " + error.message;
      
      throw new SubmissionError({ _error: errorMessage });
    } 
  }

  render() {
    const { handleSubmit, submitting, error, jobDetail } = this.props;

    return (
      <div className="site-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1>{_t("acceptLopd.title")}</h1>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="scrollableContent" >
                    <ProteccionDeDatosScreen />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card">
                <div className="card-body">
                  {error && <div className="alert alert-danger" role="alert">{error}</div>}
                  <form onSubmit={handleSubmit(this.onSubmit)}>
                    <div className="row">
                      <div className="col-md-12 mb-2">
                        <Field
                          name="nombre"
                          type="text"
                          component={AfeFields.Input}
                          placeholder={_t("jobView.nombre")}
                        />
                        <Field
                          name="apellidos"
                          type="text"
                          component={AfeFields.Input}
                          placeholder={_t("jobView.apellidos")}
                        />
                        <Field
                          name="email1"
                          type="text"
                          component={AfeFields.Input}
                          placeholder={_t("jobView.email")}
                        />
                        <Field
                          name="telefono1"
                          type="text"
                          component={AfeFields.Input}
                          placeholder={_t("jobView.phone")}
                        />
                        <Field name="cv" component={AfeFields.File} placeholder={_t("jobView.attachFile")} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 ml-4  mb-4">
                        <Field
                          name="politicaDePrivacidad"
                          type="checkbox"
                          component={AfeFields.Checkbox}
                        >
                          {_t("home.contactAcceptTermsText")}&nbsp;
                          <Link to="/home/politicaDePrivacidad">
                            {_t("footer.privacyPolicy")}
                          </Link>
                          &nbsp;/&nbsp;
                          <Link to="/home/terminosYCondiciones">
                            {_t("footer.termsAndConditions")}
                          </Link>
                          &nbsp;/&nbsp;
                          <Link to="/home/proteccionDeDatos">
                            {_t("footer.dataProtection")}
                          </Link>
                        </Field>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 ml-4  mb-4">
                        <Field
                          name="recaptcha"
                          type="hidden"
                          component={AfeFields.Input}
                        />
                        <ReCAPTCHA
                          name="recaptcha"
                          ref={recaptchaRef}
                          sitekey="6LdGfcwUAAAAAKA-dcK1A7m_q4MoVnPMVaNXDvg4"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <button
                          type="submit"
                          className="btn btn-primary font-default-normal"
                          disabled={submitting}
                        >
                          {_t("aceptar")}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.nombre) {
    errors.nombre = 'Required';
  } 
  if (!values.apellidos) {
    errors.apellidos = 'Required';
  }
  if (!values.email1) {
    errors.email1 = 'Required';
  }
  if (!values.telefono1) {
    errors.telefono1 = 'Required';
  }
  if (!values.politicaDePrivacidad) {
    errors.politicaDePrivacidad = 'You must check this field';
  }
  
  const recaptchaValue = (recaptchaRef != null && recaptchaRef.current != null) ? recaptchaRef.current.getValue() : null;

  //console.log("recaptchaValue", recaptchaValue);

  /*
  if (recaptchaValue != null && recaptchaValue != "") {
    //console.log(formValues);
  } else {
    errors.recaptcha = 'Make sure you are not a robot';
  }*/
  return errors;
}

const warn = values => {
  const warnings = {}
  return warnings;
}

const form = reduxForm({
  form: 'acceptLopdFormScreen', // a unique identifier for this form
  validate, // <--- validation function given to redux-form
  warn // <--- warning function given to redux-form
})(AcceptLopdFormScreen);

const mapStateToProps = (state, ownProps) => {
  console.log("acceptLopdFormScreen", state.jobDetail);

  return {
    initialValues: {}, 
    enableReinitialize: true,
    //jobDetail: state.jobDetail,
    formValues: getFormValues('acceptLopdFormScreen')(state)
  };
};

export default connect(mapStateToProps, {})(form);

